import PropTypes from "prop-types";
import "./Secondary.css"; // Import the CSS file
import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Typography } from "@mui/material";

export default function Secondary(props) {
   // const secondaries = getSecondaries(props.primary);

  const [secondaries, setSeconaries] = React.useState([])

  React.useEffect(() => {
    if (props.categoryMap?.primaries?.[props.primary]?.secondaries) {
      setSeconaries(Object.keys(props.categoryMap.primaries[props.primary].secondaries));
    }
  }, [props.primary, props.categoryMap]);  

  return (
    <div>
      <Typography variant="subtitle1" sx={{ mt: '1rem', ml: '5px', mb: '1rem' }}>Bitte wählen Sie aus folgenden Kategorien</Typography>
      <FormControl fullWidth sx={{ m: 1, width: '90%'}}>
      <InputLabel id="secondary-select-label">Sekundäre Kategorie</InputLabel>
      <Select
        labelId="secondary-select-label"
        id="secondary-select"
        value={props.secondary}
        onChange={props.handleChange}
        data-testid="secondary-select"
        label="Sekundäre Kategorie"
      >
        {secondaries.map((secondary) => (
          <MenuItem key={secondary} value={secondary} data-testid={`secondary-option-${secondary}`}>
            {secondary}
          </MenuItem>
        ))}
      </Select>
        {/* <InputLabel id="demo-multiple-checkbox-label">Sekundäre Kategorie</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={props.secondary}
          onChange={props.handleChange}
          input={<OutlinedInput label="Sekundäre Kategorie" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
          data-testid="secondary-select"
        >
          {secondaries.map((secondary) => (
            <MenuItem key={secondary} value={secondary}>
              <Checkbox checked={props.secondary.indexOf(secondary) > -1} />
              <ListItemText primary={secondary} />
            </MenuItem>
          ))}
        </Select> */}
      </FormControl>
    </div>
  );
}

Secondary.propTypes = {
  handleChange: PropTypes.func,
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.array.isRequired
  ]),
  categoryMap: PropTypes.object.isRequired,
};